<template>
  <div class="page-main-header" :class="{ 'landing-header': ['landing', 'Blog', 'BlogPost', 'signup'].includes($route.name) }">

    <!-- Landing page header content -->
    <div v-if="['landing', 'Blog', 'BlogPost', 'signup'].includes($route.name)" class="landing-header-container">
      <router-link :to="'/'">
        <img src="/landing-assets/planup-logo-f94670f3.png" alt="PlanUp" class="landing-logo">
      </router-link>
      <nav class="landing-nav hideForMobile">
        <a href="#features" class="landing-nav-link" @click.prevent="scrollLandingTo('features')" v-if="$route.name === 'landing'">פיצ'רים</a>
        <a href="#pricing" class="landing-nav-link" @click.prevent="scrollLandingTo('pricing')" v-if="$route.name === 'landing'">מחירים</a>
        <a href="#faq" class="landing-nav-link" @click.prevent="scrollLandingTo('faq')" v-if="$route.name === 'landing'">שאלות נפוצות</a>
        <router-link to="/blog" class="landing-nav-link">בלוג</router-link>
        <router-link to="/signup" v-if="$route.name !== 'signup'">
          <button class="landing-trial-btn">ניסיון חינם</button>
        </router-link>
        <router-link to="/login">
          <button class="landing-login-btn">כניסה למערכת</button>
        </router-link>
      </nav>
      <div class="landing-mobile-actions hideForDesktop">
        <router-link to="/blog" class="landing-mobile-blog-link">בלוג</router-link>
        <router-link to="/signup" v-if="$route.name !== 'signup'">
          <button class="landing-trial-btn-mobile">ניסיון חינם</button>
        </router-link>
        <router-link to="/login">
          <button class="landing-login-btn-mobile">כניסה</button>
        </router-link>
      </div>
    </div>

    <!-- Regular header content -->
    <div class="main-header-left" v-if="!['landing', 'Blog', 'BlogPost', 'signup'].includes($route.name)">
      <div class="logo-wrapper hideForMobile"
           style="width:235px;text-align: center;">
        <router-link :to="'/'">
          <img src="/static/planup.png?v=20260714">
        </router-link>
      </div>


      <div class="hideForDesktop menuToggleTouch"
           v-if="$store.state.isLogged"
           style="font-size:20px;padding:12px"
           @click="$emit('toggleMenu')">
        <i class="fa-solid fa-bars"></i>
      </div>





    </div>


    <div class="main-header-center" v-if="!['landing', 'Blog', 'BlogPost', 'signup'].includes($route.name)">

      <router-link to="/"
                   class="hideForDesktop">
        <img src="/static/planup.png?v=20260714"
             style="width:100px">
      </router-link>

    </div>



    <div class="hideForDesktop main-header-left"
         v-if="!$store.state.isLogged && !['landing', 'Blog', 'BlogPost', 'signup'].includes($route.name)">

    </div>

    <div class="hideForDesktop main-header-left"
         v-if="$store.state.isLogged"
         style="direction:ltr;user-select: none;">



      <li style="    list-style-type: none;padding: 12px;font-size: 20px;position: relative;top: -2px;"
          @click="$root.$emit('findCustomer', $handlers.customerHandler.goToSearchResult)">
        <i style="position:relative;top:3px;"
           class="fa-solid fa-magnifying-glass"></i>

      </li>

      <li style="    list-style-type: none;padding: 12px;font-size: 20px;position: relative;top: -2px;"
          @click="$emit('openQuickCalendar')">
        <i class="fa-regular fa-calendar"
           style="position:relative;top:2px;"></i>
      </li>

      <!-- the conversations, whatsapp and mail alike (the inbox's envelope was folded into it) -->
      <HeaderWhatsappBox :mobile="true"></HeaderWhatsappBox>

      <!-- support thread with PlanUp (the root admin is the support side, so not for type 1) -->
      <HeaderSupportButton v-if="$store.state.user && $store.state.user.type != 1"
                           :mobile="true"></HeaderSupportButton>




    </div>








    <div class="main-header-right row hideForMobile"
         v-if="$store.state.isLogged">
      <div class="nav-right col">
        <ul class="nav-menus">


          <!-- first in the DOM = rightmost icon (this row is rtl). The conversations, whatsapp
               and mail alike - the envelope that went to /messages was folded into it -->
          <HeaderWhatsappBox></HeaderWhatsappBox>

          <!-- support: opens the chat with PlanUp support (SupportModal in App.vue). Not for the
               root admin - that account answers these threads at /root-admin/support -->
          <HeaderSupportButton v-if="$store.state.user && $store.state.user.type != 1"></HeaderSupportButton>

          <!-- whatsappEverConnected survives a loggedOut (which clears whatsappServer), so the
               warning still shows when a once-linked device dropped off -->
          <router-link to="/settings?activeTab=orginizationSettings_whatsappTab"
                       v-if="($store.state.businessSettings.whatsappServer || $store.state.businessSettings.whatsappEverConnected) && $store.state.whatsappConnected === false">
            <li style="color:#b82e24;position:relative;top:3px"
                class="fa-fade">
              <i class="fa-solid fa-triangle-exclamation"></i>
              <span
                    style="    position: absolute;font-size: 12px;width: 85px;bottom: -21px;left: -31px;text-align: center;line-height: 12px;">
                Whatsapp
                <br>
                מנותק
              </span>
            </li>
          </router-link>


          <li @click="$root.$emit('findCustomer', $handlers.customerHandler.goToSearchResult)">
            <i style="position:relative;top:3px;"
               class="fa-solid fa-magnifying-glass"></i>

          </li>


          <li @click="$emit('openQuickCalendar')">
            <i class="fa-regular fa-calendar"
               style="position:relative;top:2px;"></i>
          </li>

          <li v-if="false"
              @click="toggleLanguage">
            {{ $t('langName') }}
          </li>

          <li @click="showNotifications = !showNotifications"
              v-bind:class="{ highlightHeaderButton: showNotifications }">
            <i style="position:relative;top:3px;"
               class="fa-regular fa-bell"></i>
            <span v-if="notificationCount > 0"
                  class="notification-badge">{{ notificationCount }}</span>

            <div v-show="showNotifications"
                 class="card"
                 style="left: 0;top:80px;box-shadow:0 5px 7px 0 rgba(0,0,0,.1); position:absolute;width:400px;border-radius: 0 0 6px 6px;border:solid 1px #eeee;background:white;max-height:500px;overflow-y:auto;">

              <div style="background:#eeeeee;text-align:center;font-size:18px;font-weight:600;position:relative;">
                התראות
                <router-link to="/notifications"
                             @click.native.stop="showNotifications = false"
                             style="position:absolute;left:10px;top:50%;transform:translateY(-50%);font-size:12px;color:#ab8ce4;">
                  הצג הכל
                </router-link>
              </div>

              <div>
                <div v-if="!$store.state.notifications.length"
                     style="text-align: center;padding:20px;">
                  אין התראות חדשות
                  <br>
                  <router-link to="/notifications"
                               @click.native.stop="showNotifications = false"
                               style="font-size:12px;color:#ab8ce4;">
                    צפה בהיסטוריית התראות
                  </router-link>
                </div>

                <div v-else>
                  <div v-for="notification in $store.state.notifications"
                       :key="notification.id"
                       @click="handleNotificationClick(notification)"
                       style="padding: 10px;border-bottom: solid 1px #eeeeee;cursor:pointer;position:relative;"
                       class="headerNotificationRow">
                    <div @click.stop="dismissNotification(notification)"
                         class="notification-dismiss-btn"
                         title="סגור">
                      <i class="fa-solid fa-xmark"></i>
                    </div>
                    <div style="font-weight:600;margin-bottom:5px;padding-left:20px;">
                      {{ notification.text }}
                    </div>
                    <div style="font-size:12px;color:#888;">
                      {{ getNotificationSubtext(notification) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li @click="showLog = !showLog"
              v-bind:class="{ highlightHeaderButton: showLog }">
            <i style="position:relative;top:3px;"
               class="fa-regular fa-clock"></i>

            <div v-show="showLog"
                 class="card"
                 style="left: 0;top:80px;box-shadow:0 5px 7px 0 rgba(0,0,0,.1); position:absolute;width:300px;border-radius: 0 0 6px 6px;border:solid 1px #eeee;background:white;">

              <div style="background:#eeeeee;text-align:center;font-size:18px;font-weight:600">
                פעולות אחרונות

              </div>


              <div>


                <div v-if="!logs.length"
                     style="text-align: center;">
                  <br>
                  <br>
                  <i class="fa-solid fa-spinner fa-spin"></i>
                  <br>
                  <br>
                  <br>
                </div>


                <div v-else>

                  <div @click="$globals.clickOnItem(log.table, log.entityId, log)"
                       v-for="log in logs"
                       style="padding: 10px 5px;border-bottom: solid 1px #eeeeee"
                       class="headerLogRow">



                    {{ $handlers.logHandler.actionToText(log.action, log.table) }}
                    {{ $handlers.logHandler.logTableToText(log.action, log.table) }}



                    <div style="display:inline-block;">
                      {{ log.value.name }}
                      {{ log.value.title }}
                      {{ log.value.firstName }}
                      {{ log.value.lastName }}

                    </div>

                  </div>

                </div>



              </div>



            </div>

          </li>



          <li>
            <span style="color:#ab8ce4;font-weight:bold;">{{ getUserName }}</span>
          </li>


        </ul>
      </div>
    </div>




    <ul style="display:none"
        v-if="false"
        class="headernav-ul">
      <li class="l_user">
        <div class="dropdown"
             style="float: right">
          <button class="selectBtn"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
            <!--<span class="profileImg"><img src="/static/images/user.png" alt=""></span>-->
            <span class="badge"
                  style="color: white; background: #293b5a; margin: 0 3px"
                  v-can:messages="'view'">
              {{ messageCount }}
            </span>
            <span>{{ $t("hello") }} {{ getUserName }}</span>
            <svg class="i_select">
              <use xlink:href="#i_select"></use>
            </svg>
          </button>
          <div class="dropdown-menu">
            <ul>
              <li v-can:messages="'view'">
                <router-link to="/messages">
                  <svg class="i_user">
                    <use xlink:href="#i_message"></use>
                  </svg>
                  <span>{{ messageCount }} {{ $t("messages") }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/profile">
                  <svg class="i_user">
                    <use xlink:href="#i_user"></use>
                  </svg>
                  <span>{{ $t("myProfile") }}</span>
                </router-link>
              </li>
              <li>
                <a href="#"
                   @click.prevent="logOff">
                  <svg class="i_logout">
                    <use xlink:href="#i_logout"></use>
                  </svg>
                  <span>{{ $t("logoff") }}</span>
                </a>
              </li>

            </ul>
          </div>
        </div>
      </li>


      <li class="l_lang">
        <LanguageSelector></LanguageSelector>
      </li>


      <li class="l_info">
        <div class="dropdown">
          <button class="selectBtn"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
            <svg class="i_info">
              <use xlink:href="#i_info"></use>
            </svg>
            <span>{{ $t("support") }}</span>
            <svg class="i_select">
              <use xlink:href="#i_select"></use>
            </svg>
          </button>
          <div class="dropdown-menu">
            <ul>
              <li>
                <a href="#"
                   class="trigger"
                   id="contactUs"
                   @click="openContactModal">
                  <svg class="i_contact">
                    <use xlink:href="#i_contact"></use>
                  </svg>
                  <span>{{ $t("contact") }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>

      <li class="l_info">
        <div class="dropdown">
          <button @click="openVideo"
                  class="selectBtn"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
            <svg class="i_help">
              <use xlink:href="#i_help"></use>
            </svg>
            <span>{{ $t("getStarted") }}</span>
          </button>
        </div>
      </li>

    </ul>

  </div>
</template>

<script>
import axiosV2 from "../../core/http/axios_api_v2";
import LanguageSelector from "./LanguageSelector";
import HeaderWhatsappBox from "../PlanupMultiMessages/HeaderWhatsappBox.vue";
import HeaderSupportButton from "../Support/HeaderSupportButton.vue";
import Vue from 'vue'

export default {
  name: "HeaderNav",
  data() {
    return {
      showLog: false,
      showNotifications: false,
      logs: [],
      // pandaNotifications: []
    };
  },
  sockets: {

  },
  watch: {
    showLog: function (val) {

      if (val) {
        axiosV2('/tracking-log/?sortField=&sortType=&page=1&perPage=5&searchTerm=').then((response) => {

          this.logs = response.data.rows
        });
      } else {
        this.logs = [];
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    getUserName() {
      return this.user ? this.user.name : "";
    },

    messageCount() {

      let m = this.$store.state.TasksStore.inbox.filter(
        (x) => !x.msg_to_user || x.msg_to_user.status != "completed"
      );
      if (m) return m.length;
      return 0;
    },
    
    notificationCount() {
      return this.$store.state.notifications ? this.$store.state.notifications.length : 0;
    },
  },
  mounted() {

    //the whatsapp box opens over the same spot as these two - it asks them to get out of the way
    this.$root.$on('closeHeaderDropdowns', this.closeDropdowns);

    // this.$socket.on(this.$socket.id, (data) => {
    //   const socketData = data.data
    //   const socketType = data.type

    //   switch (socketType) {
    //     case 'quote_reminder':
    //     this.$store.commit('addMessage', socketData.message)
    //       this.$notify({
    //         title: 'תזכורת לסגור עיסקה',
    //         text: socketData.clientName,
    //         route: '/browse/quotation'
    //       });
    //       break;
    //     case 'message_received':
    //       this.$store.commit('addMessage', socketData)
    //       this.$notify({
    //         title: 'קיבלתם הודעה!',
    //         text: socketData.title,
    //         route: '/browse/quotation'
    //       });
    //       break;
    //   }
    // })
  },
  beforeDestroy() {
    this.$root.$off('closeHeaderDropdowns', this.closeDropdowns);
  },
  methods: {
    closeDropdowns() {
      this.showNotifications = false;
      this.showLog = false;
    },

    handleNotificationClick(notification) {
      // Navigate based on notification content. An explicit link (e.g. '/booking-requests')
      // wins over the customer/event fallbacks.
      // 'chat:<msgGroup>' opens the conversation modal instead of routing - an incoming email
      // has no page of its own, it lives in the global chat box.
      if (notification.link && notification.link.slice(0, 5) == 'chat:') {
        this.$root.$emit('globalChatBox', notification.link.slice(5));
      // 'duplicate:<newCustomerId>:<existingCustomerId>' is a lead that arrived with a phone we
      // already had - it opens the merge-or-keep modal rather than routing anywhere.
      } else if (notification.link && notification.link.slice(0, 10) == 'duplicate:') {
        var ids = notification.link.slice(10).split(':');
        this.$root.$emit('resolveDuplicatePhone', ids[0], ids[1]);
      } else if (notification.link) {
        this.$router.push(notification.link);
      } else if (notification.customerId) {
        this.$router.push(`/customer/${notification.customerId}`);
      } else if (notification.eventId) {
        this.$router.push(`/event/${notification.eventId}`);
      }

      // Mark as seen
      axiosV2.patch(`/notifications/${notification.id}`, { seen: true }).then(() => {
        // Remove from local state
        const index = this.$store.state.notifications.findIndex(n => n.id === notification.id);
        if (index > -1) {
          this.$store.state.notifications.splice(index, 1);
        }
      });

      this.showNotifications = false;
    },

    dismissNotification(notification) {
      // Mark as seen without navigating
      axiosV2.patch(`/notifications/${notification.id}`, { seen: true }).then(() => {
        // Remove from local state
        const index = this.$store.state.notifications.findIndex(n => n.id === notification.id);
        if (index > -1) {
          this.$store.state.notifications.splice(index, 1);
        }
      });
    },
    
    getNotificationSubtext(notification) {
      // Show customer name if available
      if (notification.customer && notification.customer.contacts && notification.customer.contacts.length > 0) {
        var names = notification.customer.contacts.map(function(c) {
          return c.firstName + (c.lastName ? ' ' + c.lastName : '');
        });
        return names.join(' ו');
      }
      // Show event name if available
      if (notification.event && notification.event.name) {
        return notification.event.name;
      }
      // Fallback to date
      return this.formatDate(notification.created);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      var date = new Date(dateString);
      var now = new Date();
      var diffMs = now - date;
      var diffMins = Math.floor(diffMs / 60000);

      if (diffMins < 1) return 'עכשיו';
      if (diffMins < 60) return 'לפני ' + diffMins + ' דקות';

      var diffHours = Math.floor(diffMins / 60);
      if (diffHours < 24) return 'לפני ' + diffHours + ' שעות';

      var diffDays = Math.floor(diffHours / 24);
      if (diffDays < 7) return 'לפני ' + diffDays + ' ימים';

      return date.toLocaleDateString('he-IL');
    },
    
    toggleLanguage() {

      if (Vue.i18n.locale() == 'he') {

        document.body.classList.remove('rtl');
        Vue.i18n.set('en');
        this.$store.dispatch('saveLang', 'en');

      } else {

        document.body.classList.add('rtl');
        Vue.i18n.set('he');
        this.$store.dispatch('saveLang', 'he');

      }

    },
    openVideo() {
      window.open("https://vimeo.com/303576733");
    },
    logOff() {


      //yonso hardcore logoff instead:
      document.cookie = `token=; path=/;SameSite=strict; Secure;`;
      localStorage.removeItem('tenantId');
      window.location.href = `http://${window.location.host}`;


      //previous logoff

      // this.$store
      //   .dispatch("logoff")
      //   .then((response) => {
      //     this.$router.push("/login");
      //   })
      //   .catch((err) => {
      //     console.warn("Failed to logoff - ", err);
      //     this.$router.replace("/login", function () {
      //       setTimeout(function () {
      //         location.reload();
      //       }, 1000);
      //     });
      //   });
    },

    openContactModal() {
      $("#modal-custom").iziModal({
        autoOpen: 1,
      });
    },

    scrollLandingTo(sectionId) {
      var iframe = document.querySelector('.landing-iframe');
      if (iframe && iframe.contentWindow) {
        var element = iframe.contentDocument.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

    changeMenuState() {
      if (this.$store.state.isKiosk && !this.$store.state.isTablet) return;
      if (this.$store.state.preferences.menuState == "closed") {
        this.$store.dispatch("saveMenuState", "open").then((response) => {
          //on success
          document.body.classList.add("menu_open");
        });
      } else {
        this.$store.dispatch("saveMenuState", "closed").then((response) => {
          //on success
          document.body.classList.remove("menu_open");
        });
      }
    },
  },

  components: {
    LanguageSelector,
    HeaderWhatsappBox,
    HeaderSupportButton,
  },
};
</script>
<style>
/* yonso fixing css of universal */
.page-main-header .main-header-right .nav-right>ul>li {
  cursor: pointer;
  user-select: none;
}

.rtl .page-main-header .main-header-right .nav-right>ul>li {
  margin-left: 0;
  margin-right: 30px;
}

.notification-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ff5370;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: bold;
  min-width: 18px;
  text-align: center;
}

.headerNotificationRow:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.notification-dismiss-btn {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #888;
  transition: all 0.2s;
}

.notification-dismiss-btn:hover {
  background-color: #e0e0e0;
  color: #333;
}

.highlightHeaderButton {
  background-color: rgba(171, 140, 228, 0.1);
  border-radius: 4px;
}

/* Landing page navigation styles */
.landing-nav-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.landing-nav-link:hover {
  color: #ab8ce4;
}

.landing-login-btn {
  background: white;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.landing-login-btn:hover {
  background: #f5f5f5;
  border-color: #ab8ce4;
}

/* the header's trial CTA (landing / blog): the self-signup wizard at /signup */
.landing-trial-btn {
  background: #ab8ce4;
  color: white;
  border: 1px solid #ab8ce4;
  padding: 8px 18px;
  border-radius: 6px;
  font-weight: 400;
  cursor: pointer;
  margin-left: 8px;
  transition: background 0.2s;
}

.landing-trial-btn:hover {
  background: #9878d6;
}

/* Landing page header specific styles */
.page-main-header.landing-header {
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
}

@media (min-width: 768px) {
  .page-main-header.landing-header {
    height: 80px;
  }
}

.landing-header-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.landing-logo {
  height: 32px;
}

@media (min-width: 768px) {
  .landing-logo {
    height: 40px;
  }
}

.landing-nav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.landing-login-btn-mobile {
  background: white;
  color: #ab8ce4;
  border: 1px solid #ab8ce4;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.landing-login-btn-mobile:hover {
  background: #ab8ce4;
  color: white;
}

.landing-trial-btn-mobile {
  background: #ab8ce4;
  color: white;
  border: 1px solid #ab8ce4;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 400;
  cursor: pointer;
  margin-left: 6px;
}

.landing-mobile-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.landing-mobile-blog-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: color 0.2s;
}

.landing-mobile-blog-link:hover {
  color: #ab8ce4;
}
</style>
